var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 285,
    height: 532,
    viewBox: "0 0 2850 5320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l21IDKcAlzNQOFVzi1tQxtQ",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "p7WMlxkFM",
    d: "M1450 5279 c-35 -68 -61 -212 -62 -339 -1 -142 11 -221 67 -420 63 -224 69 -262 69 -395 -1 -151 -9 -188 -100 -468 -41 -126 -84 -272 -96 -325 -37 -177 -24 -406 35 -603 l14 -46 -68 -6 c-149 -13 -169 -55 -95 -201 24 -47 42 -86 40 -86 -2 0 -66 30 -141 66 -488 234 -484 233 -561 182 -31 -21 -44 -38 -52 -70 -12 -43 -10 -65 39 -393 11 -71 29 -195 41 -274 11 -80 23 -148 26 -152 15 -26 -44 -95 -275 -319 -139 -135 -267 -265 -286 -290 -43 -59 -50 -96 -29 -149 20 -50 61 -74 155 -91 35 -6 87 -15 114 -20 28 -6 169 -31 315 -56 146 -25 279 -50 297 -55 27 -9 42 -29 114 -162 45 -84 94 -174 109 -202 15 -27 56 -104 90 -170 35 -66 74 -137 87 -158 31 -50 91 -77 160 -74 28 1 50 3 49 5 -2 1 13 19 32 40 20 21 106 176 202 360 92 178 175 332 186 342 13 13 49 24 109 34 411 69 682 117 715 127 85 26 121 141 67 212 -13 18 -129 136 -257 262 -128 127 -249 245 -267 264 -51 51 -54 65 -32 187 10 60 33 195 49 299 17 105 38 228 46 274 18 107 18 145 -2 187 -21 43 -90 79 -138 70 -18 -4 -166 -71 -329 -150 -164 -80 -297 -142 -297 -139 0 3 8 17 19 31 36 51 81 152 81 180 0 53 -71 91 -172 92 -36 0 -38 1 -53 53 -55 186 -73 396 -46 557 7 41 48 181 91 310 95 287 113 367 113 525 0 141 -10 203 -63 385 -64 219 -72 270 -72 425 0 141 10 198 48 297 17 46 17 48 -1 68 -30 33 -62 26 -85 -21z m77 -2746 c-41 -74 -91 -153 -98 -153 -4 0 -20 21 -35 48 -15 26 -36 62 -46 80 l-20 32 102 0 c56 0 99 -3 97 -7z m-756 -67 c74 -35 240 -112 369 -172 234 -108 235 -109 310 -109 75 0 76 1 285 104 329 162 476 231 491 231 10 0 13 -7 9 -22 -3 -13 -30 -174 -60 -358 -61 -371 -68 -472 -36 -524 11 -17 144 -152 296 -300 190 -186 272 -272 263 -277 -7 -4 -173 -34 -368 -68 -419 -73 -479 -86 -502 -109 -10 -9 -83 -143 -163 -297 -160 -307 -225 -425 -235 -425 -8 0 -11 6 -210 375 -168 312 -204 366 -254 379 -11 3 -190 35 -396 71 -418 73 -410 72 -410 89 0 11 367 379 470 472 94 84 100 95 100 192 0 89 -4 114 -65 522 -33 219 -40 290 -31 290 2 0 64 -29 137 -64z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6MxDXnvcN1xEiJ3WoZJdtJ",
    fill: "rgb(239,182,55)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pMKTA6EWt",
    d: "M1422 2573 l-153 -4 47 -87 c63 -115 103 -174 117 -169 19 6 157 236 157 262 0 3 -3 4 -7 3 -5 -1 -77 -4 -161 -5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "pfHpvv6vG",
    d: "M605 2554 c-13 -13 -16 -27 -11 -53 3 -20 6 -48 6 -63 0 -21 5 -28 20 -28 11 0 20 7 20 15 0 8 5 15 10 15 6 0 10 -4 10 -8 0 -9 60 -38 90 -44 30 -6 340 -168 340 -178 0 -6 8 -10 18 -10 19 0 153 -65 162 -79 16 -25 74 -41 147 -41 74 0 82 2 198 59 180 88 343 166 404 192 l54 23 18 -23 c21 -26 24 -62 9 -89 -15 -27 -59 -353 -66 -497 -6 -111 -4 -135 10 -163 17 -33 158 -177 183 -186 7 -3 17 -16 22 -28 10 -26 68 -82 94 -91 9 -4 21 -17 26 -29 10 -24 104 -118 118 -118 21 0 113 -110 113 -135 0 -11 6 -15 18 -11 9 3 35 8 57 12 46 8 55 17 55 61 0 28 -29 59 -271 294 -148 145 -279 277 -290 295 -12 20 -19 49 -19 80 0 27 27 213 60 414 34 201 60 376 58 389 -8 61 -25 55 -523 -190 -205 -101 -258 -123 -295 -123 -45 -1 -189 62 -649 281 -162 76 -173 80 -196 57z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l7ZvlRzu2916TPFEcOG71QS",
    fill: "rgb(252,209,82)",
    style: {
      transform: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "none"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "pPyqlmx5g",
    d: "M627 2563 c-4 -3 -7 -12 -7 -20 0 -11 4 -11 20 -3 11 6 18 15 15 21 -7 11 -19 12 -28 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "pRjCkUiA1",
    d: "M1325 2563 c121 -7 255 -7 255 0 0 4 -69 6 -152 5 -84 -1 -130 -3 -103 -5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "pKy5ewNpW",
    d: "M2211 2561 c-11 -7 -9 -10 8 -16 25 -8 36 -2 26 14 -8 13 -15 14 -34 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "p1Ghoqw6Fa",
    d: "M594 2526 c-3 -14 -3 -30 1 -36 3 -6 8 -32 10 -58 4 -43 13 -111 75 -522 11 -74 20 -161 20 -192 0 -63 -14 -85 -100 -162 -108 -97 -463 -454 -476 -479 -17 -31 -6 -62 23 -71 10 -3 187 -35 393 -71 206 -36 385 -68 396 -71 50 -13 86 -67 254 -379 212 -394 201 -374 222 -381 49 -15 54 -8 283 431 80 154 153 288 163 297 23 23 88 37 447 98 165 29 307 54 315 57 8 3 22 5 32 4 9 -1 19 3 23 9 3 6 11 8 16 5 5 -4 18 -3 29 0 35 11 26 65 -17 106 -21 18 -30 25 -20 13 19 -24 22 -44 6 -44 -8 0 -8 -4 -1 -13 7 -8 6 -18 -3 -31 -14 -18 -15 -18 -50 8 -19 15 -40 36 -46 48 -15 28 -60 67 -78 68 -8 0 -11 3 -8 7 4 3 -3 11 -16 18 -12 6 -21 17 -19 23 1 7 -4 12 -11 12 -8 0 -24 11 -37 25 -13 14 -20 25 -15 25 4 0 0 9 -10 20 -10 11 -23 20 -30 20 -14 0 -80 69 -88 93 -4 9 -12 20 -20 22 -14 6 -161 145 -152 145 3 0 -4 9 -15 20 -12 12 -18 25 -15 30 4 6 2 10 -4 10 -13 0 -6 129 15 290 2 19 6 49 7 66 2 17 7 35 10 41 4 6 7 22 6 34 0 13 3 42 6 64 4 22 8 49 10 60 1 11 5 27 8 35 13 37 17 103 6 116 -6 8 -8 14 -4 14 4 0 -4 9 -18 20 -14 11 -32 20 -41 20 -29 0 -165 -61 -491 -221 -100 -49 -128 -58 -170 -58 -46 1 -103 21 -115 40 -10 14 -143 79 -164 79 -10 0 -16 3 -12 7 7 7 -329 182 -351 183 -18 0 -83 32 -83 41 0 4 -18 10 -40 14 -40 7 -45 14 -42 58 2 25 -7 21 -14 -7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "pE4oa9qwv",
    d: "M700 2526 c0 -16 37 -32 48 -21 7 7 -25 35 -40 35 -4 0 -8 -6 -8 -14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "p1EhCQgrR7",
    d: "M766 2495 c-3 -9 0 -15 9 -15 16 0 20 16 6 24 -5 3 -11 -1 -15 -9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "pmM85uIy4",
    d: "M1846 2387 c-16 -12 -16 -14 -2 -14 9 0 16 4 16 9 0 5 5 6 10 3 6 -3 10 -1 10 4 0 15 -12 14 -34 -2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "pphVfM32l",
    d: "M1758 2344 c-16 -8 -28 -17 -28 -20 0 -2 8 0 19 5 10 6 20 9 22 7 2 -2 10 2 17 10 16 18 4 17 -30 -2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "pYsgbRttS",
    d: "M1170 2306 c0 -9 7 -16 16 -16 17 0 14 22 -4 28 -7 2 -12 -3 -12 -12z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "plpmMLGh3",
    d: "M2155 1652 c9 -18 13 -37 10 -42 -3 -6 2 -10 11 -10 10 0 27 -8 38 -17 11 -10 7 -2 -9 17 -17 20 -38 47 -48 60 -17 25 -17 25 -2 -8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "pOzlc01Ys",
    d: "M2268 1529 c13 -15 22 -32 20 -40 -2 -7 5 -15 15 -17 27 -6 20 11 -20 49 -21 18 -28 22 -15 8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "p10btYaxHi",
    d: "M2450 1347 c62 -64 116 -115 118 -113 4 4 -63 71 -164 166 -38 35 -17 12 46 -53z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "pGWBOU5hF",
    d: "M2580 1223 c0 -5 11 -20 25 -33 14 -13 25 -19 25 -13 0 5 -11 20 -25 33 -14 13 -25 19 -25 13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon4);
export default __webpack_public_path__ + "static/media/balloon4.e3a781fee23e940c010b92cf113d44b9.svg";
export { ForwardRef as ReactComponent };